/**
 * Validates that a URL uses a safe protocol (http, https, or blob).
 * Prevents javascript:, data:, or other potentially malicious URI schemes.
 */
export const isSafeUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url, window.location.origin);
    return (
      parsed.protocol === 'https:' || parsed.protocol === 'http:' || parsed.protocol === 'blob:'
    );
  } catch {
    return false;
  }
};
